import { AxiosInstance } from 'axios';
import { makeObservable, observable, runInAction } from 'mobx';
import GlobalStore from './GlobalStore';
import CertificateModel from '../Models/CertificateReportModel';

export default class CertificateReportStore {
    constructor(globalStore: GlobalStore) {
        this.axios = globalStore.axios;
        this.globalStore = globalStore;

        makeObservable(this, {
            model: observable,
            initialised: observable,
            hasAccess: observable
        });
    }

    readonly globalStore: GlobalStore;

    readonly axios: AxiosInstance;

    model?: CertificateModel;

    hasAccess = true;

    initialised = false;

    initialiseAsync = async () => {
        if (this.initialised) {
            return;
        }
        runInAction(() => {
            this.initialised = true;
        });

        await this.axios.get<CertificateModel>('/api/certificate')
            .then(model => {
                this.model = model.data;
            }, err => {
                if (err.response.status === 401) {
                    runInAction(() => {
                        this.hasAccess = false;
                    });
                } else {
                    runInAction(() => {
                        this.globalStore.hasError = true;
                    });
                }
            });
    };
}
